export const createArtProductServerConfiguration = (artProduct) => {
  const {
    id,
    setName,
    name,
    tags,
    image,
    thumbnailImage,
    naturalWidth,
    naturalHeight,
    thumbnailWidth,
    thumbnailHeight,
    scale,
    translateX,
    translateY,
    cropOrientation,
  } = artProduct;

  return {
    Configuration: {
      Id: id,
      SetName: setName,
      Name: name,
      Tags: tags,
      ImageUrl: image,
      ThumbnailImageUrl: thumbnailImage,
      NaturalWidth: naturalWidth,
      NaturalHeight: naturalHeight,
      ThumbnailWidth: thumbnailWidth,
      ThumbnailHeight: thumbnailHeight,
      ZoomScale: scale,
      TranslateX: translateX,
      TranslateY: translateY,
      CropOrientation: cropOrientation,
    },
    Price: {
      Price: 39,
      Currencly: 'ILS',
    },
    Quantity: 1,
  };
};
